import { MenuOutlined } from '@ant-design/icons';
import { BackTop, Button, Col, ConfigProvider, Drawer, Layout, Row, message } from 'antd';
import * as React from 'react';
import * as intl from 'react-intl-universal';
import { Link, withRouter } from 'react-router-dom';
const { Header, Content } = Layout;
// import Timing from '../../components/Timing';
import { LangLocale, Language } from 'common/i18n';
import Image from '../../components/Image';
import Copyright from './Copyright';
import Menu from './Menu';
import Router from './Router';
import Shortcuts from './Shortcuts';
import { CopyrightConfig, MetaRoute, Routes, RoutesConfig, ShortcutsConfig } from './type';

export interface iProps {
    roleType: 'Admin' | 'Sales' | 'Client';
    lang: Language;
    logo: {
        url: { [key: string]: string };
        alt?: string;
        website?: string;
        isToAccount?: boolean;
    };
    routesConfig: RoutesConfig;
    shortcutsConfig: ShortcutsConfig;
    affixConfig: JSX.Element;
    clock: {
        timezone: number;
        isDST: boolean;
        format: string;
    };
    timing: {
        timeout: number;
        action: Function;
    };
    copyright?: CopyrightConfig;
    location?: any;
    children?: JSX.Element;
}

interface iMenuProps {
    roleType: 'Admin' | 'Sales' | 'Client';
    menu: any;
    activeKeys: Array<string>;
}

interface iMenuState {
    collapsed: boolean;
    openKeys: Array<string>;
}

interface iLauncherState {
    isMobile: boolean;
    mobileMenuVisible: boolean;
    mobileOpenKeys: string[];
}

message.config({
    duration: 5,
    maxCount: 3,
});

class MenuSider extends React.Component<iMenuProps, iMenuState> {
    menu: any = null;
    activeKeys: Array<string> = null;

    constructor(props: any) {
        super(props);
        const { menu, activeKeys } = props;
        // 初始化menu / activeKeys
        this.menu = menu;
        this.activeKeys = activeKeys;

        // 初始化state
        this.state = {
            collapsed: false,
            openKeys: [this.activeKeys[1]],
        };
    }

    UNSAFE_componentWillReceiveProps({ activeKeys }: any) {
        // 重置sider状态
        activeKeys[0] !== this.activeKeys[0] && this.setState({ collapsed: false });
        // 重置openKeys
        activeKeys[1] !== this.activeKeys[1] &&
            this.setState({
                openKeys: [activeKeys[1]],
            });
        this.activeKeys = activeKeys;
    }

    /**
     * Sider展开/收起
     * @param {boolean} collapsed
     */
    collapseHandler = (collapsed: boolean) => {
        this.setState({ collapsed });
    };

    /**
     * SubMenu展开/收起
     * @param {string} key
     */
    openChangeHandler = (key: string) => {
        let { openKeys } = this.state;
        this.setState({ openKeys: openKeys.includes(key) ? [] : [key] });
    };

    render() {
        const { roleType, menu } = this.props;
        const { collapsed, openKeys } = this.state;
        return (
            <>
                {Menu.Sider({
                    roleType,
                    routes: menu.sider[this.activeKeys[0]],
                    collapsed: collapsed,
                    onCollapse: this.collapseHandler,
                    openKeys: openKeys,
                    onOpenChange: this.openChangeHandler,
                    activeKeys:
                        this.activeKeys.length > 1 ? [this.activeKeys[1], this.activeKeys[2]] : [this.activeKeys[0]],
                })}
            </>
        );
    }
}

class LauncherCore extends React.Component<iProps, iLauncherState> {
    menu: any = null;
    activeKeys: Array<string> = null;
    private mobileMediaQuery?: MediaQueryList;

    constructor(props: iProps) {
        super(props);
        const { routesConfig, location } = props;

        // 初始化menu / activeKeys
        this.menu = this.getMenu(routesConfig.routes);
        this.activeKeys = this.getActiveKeys(location.pathname);
        this.state = {
            isMobile: window.matchMedia('(max-width: 768px)').matches,
            mobileMenuVisible: false,
            mobileOpenKeys: this.activeKeys.slice(0, 2),
        };
    }

    componentDidMount() {
        this.mobileMediaQuery = window.matchMedia('(max-width: 768px)');
        this.mobileMediaQuery.addEventListener('change', this.handleMobileChange);
    }

    componentWillUnmount() {
        this.mobileMediaQuery?.removeEventListener('change', this.handleMobileChange);
    }

    handleMobileChange = ({ matches }: MediaQueryListEvent) => {
        this.setState({
            isMobile: matches,
            mobileMenuVisible: matches ? this.state.mobileMenuVisible : false,
        });
    };

    UNSAFE_componentWillReceiveProps({ location }: iProps) {
        // 获取当前activeKeys
        const activeKeys = this.getActiveKeys(location.pathname);
        const routeChanged = activeKeys.join('/') !== this.activeKeys.join('/');
        this.activeKeys = activeKeys;
        if (routeChanged) {
            this.setState({
                mobileMenuVisible: false,
                mobileOpenKeys: activeKeys.slice(0, 2),
            });
        }
    }

    /**
     * 导航菜单数据
     * @param {Routes} routes
     */
    getMenu = (routes: Routes) =>
        routes.reduce(
            (menu: any, { children, ...route }: MetaRoute) => ({
                header: (menu.header || []).concat([route]),
                sider: { ...menu.sider, [route.key]: children },
            }),
            {},
        );

    /**
     * 获取active keys
     * @param {string} pathname
     */
    getActiveKeys = (pathname: string) =>
        pathname
            .toUpperCase()
            .split('/')
            .filter((key: string) => !!key)
            .reduce(
                (activeKeys: any, key: string, index: number) =>
                    activeKeys.concat(index ? [[activeKeys[index - 1], key].join('_')] : [key]),
                [],
            );

    render() {
        const { lang, logo, routesConfig, shortcutsConfig, copyright, children, roleType } = this.props;
        const { isMobile, mobileMenuVisible, mobileOpenKeys } = this.state;
        const currentModuleTitle = this.activeKeys[0] ? intl.get(`Menu.${roleType}${this.activeKeys[0]}`) : '';
        localStorage.setItem('company', copyright.company);
        return (
            <ConfigProvider locale={LangLocale[lang]}>
                {/* <Timing {...timing}> */}
                <Layout className="Launcher">
                    <Header className={`Launcher-header ${isMobile ? 'Launcher-mobile-header' : ''}`}>
                        {isMobile ? (
                            <Row className="Launcher-mobile-header-row" wrap={false}>
                                <Col className="Launcher-mobile-header-main" flex="auto">
                                    <Button
                                        className="Launcher-mobile-menu-button"
                                        type="text"
                                        icon={<MenuOutlined />}
                                        aria-label="Open navigation"
                                        onClick={() => {
                                            this.setState({ mobileMenuVisible: true });
                                        }}
                                    />
                                    <span className="Launcher-mobile-module-title" title={currentModuleTitle}>
                                        {currentModuleTitle}
                                    </span>
                                </Col>
                                <Col className="Launcher-mobile-shortcuts-column" flex="none">
                                    <Shortcuts
                                        className="Launcher-shortcuts Launcher-mobile-shortcuts navigation"
                                        config={shortcutsConfig}
                                        roleType={roleType}
                                        mobile={true}
                                        visibleKeys={['LANG', 'NOTICE', 'ACCOUNT']}
                                    />
                                </Col>
                            </Row>
                        ) : (
                            <Row>
                                <Col className="Launcher-header-nav">
                                    <div className="logo">
                                        <Link to={!logo.isToAccount ? '/' : '/home/dashboard/overview'}>
                                            <Image url={logo.url} alt={logo.alt} />
                                        </Link>
                                    </div>
                                    {Menu.Header({
                                        roleType,
                                        routes: routesConfig.routes,
                                        activeKeys: [this.activeKeys[0]],
                                    })}
                                </Col>
                                <Col flex="220px">
                                    <Shortcuts
                                        className="Launcher-shortcuts navigation"
                                        config={shortcutsConfig}
                                        roleType={roleType}
                                    />
                                </Col>
                            </Row>
                        )}
                    </Header>
                    {isMobile && (
                        <Drawer
                            className="Launcher-mobile-drawer"
                            title={currentModuleTitle}
                            placement="left"
                            width="86vw"
                            visible={mobileMenuVisible}
                            destroyOnClose={false}
                            onClose={() => {
                                this.setState({ mobileMenuVisible: false });
                            }}
                        >
                            {Menu.Mobile({
                                roleType,
                                routes: routesConfig.routes,
                                activeKeys: this.activeKeys,
                                openKeys: mobileOpenKeys,
                                onOpenChange: (keys) => {
                                    this.setState({ mobileOpenKeys: keys });
                                },
                                onNavigate: () => {
                                    this.setState({ mobileMenuVisible: false });
                                },
                            })}
                        </Drawer>
                    )}
                    <Layout className={`Launcher-body ${isMobile ? 'Launcher-mobile-body' : ''}`}>
                        {!isMobile && <MenuSider roleType={roleType} menu={this.menu} activeKeys={this.activeKeys} />}
                        <Layout id="Launcher-right" style={{ position: 'relative' }}>
                            <Content className="Launcher-content">{children}</Content>
                            <Copyright {...(copyright || {})} />
                            <BackTop target={() => document.getElementById('Launcher-right')} />
                        </Layout>
                    </Layout>
                    {/* <div className="Launcher-affix">{affixConfig}</div> */}
                </Layout>
                {/* </Timing> */}
            </ConfigProvider>
        );
    }
}

export default withRouter(
    class Launcher extends React.Component<iProps> {
        componentDidMount(): void {
            if (document.querySelector('meta[name=viewport]')) {
                document.querySelector('meta[name=viewport]').content =
                    'width=device-width, initial-scale=1, maximum-scale=1.0';
            }
        }

        render() {
            const { location, routesConfig } = this.props;
            return (
                <LauncherCore {...this.props}>
                    <Router location={location} config={routesConfig} />
                </LauncherCore>
            );
        }
    } as any,
);
